// VIT-16775 simplified the footer to a single row of links. Each entry points

import { href, Link, NavLink } from 'react-router'
// Imported (not a `public/` path) so Vite fingerprints it into
// `/assets/wordmark-light-<hash>.svg` and it caches across page loads, rather
// than inlining the SVG markup into every SSR'd HTML document (VIT-17790).
import wordmarkLightUrl from '../images/wordmark-light.svg'

// at a real stub page rather than the old placeholder columns.
// Exported so sitemap.unit.test.ts can assert the sitemap doesn't silently omit
// a footer page. The sitemap keeps its own explicit path list rather than
// importing these — see STATIC_PATHS in sitemap.ts.
export const COMPANY_LINKS = [
  { label: 'MCP Apps', href: href('/mcp-apps') },
  { label: 'Support', href: href('/support') },
]

export const LEGAL_LINKS = [
  { label: 'Terms of Use', href: href('/terms') },
  { label: 'Privacy Policy', href: href('/privacy') },
]

export function SiteFooter() {
  return (
    <footer className="bg-black text-white pb-8 xs:pb-8 pt-8 xs:pt-10 px-4 ">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="lg:max-w-[400px]">
            <Link to="/" title="Home">
              <img
                src={wordmarkLightUrl}
                alt="Vital Atlas"
                width={220}
                height={50}
                className="w-full h-auto mb-8 max-w-[221px]"
              />
            </Link>
            <p className="text-sm text-white/70 mb-4 leading-relaxed">
              Making high-quality healthcare accessible to everyone. Find and book top-rated medical specialists
              tailored for your condition.
            </p>
          </div>
          <nav aria-label="Footer" className="sm:ml-auto grid grid-cols-2 gap-12">
            <div className="space-y-3">
              <h2 className="font-sans font-bold text-sm uppercase tracking-wider">Company</h2>
              {COMPANY_LINKS.map((link) => (
                <NavLink
                  className="text-white text-sm no-underline transition-colors block text-white/70 [&.active]:text-white hover:text-white"
                  to={link.href}
                  key={link.href}
                  prefetch="viewport"
                >
                  {link.label}
                </NavLink>
              ))}
            </div>

            <div className="space-y-3">
              <h2 className="font-sans font-bold text-sm uppercase tracking-wider">Legal</h2>
              {LEGAL_LINKS.map((link) => (
                <NavLink
                  className="text-white text-sm no-underline transition-colors block text-white/70 [&.active]:text-white hover:text-white"
                  to={link.href}
                  key={link.href}
                  prefetch="viewport"
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </div>

        <div className="h-4" />

        <div className="border-t border-secondary-800 pt-4">
          <span className="text-xs text-secondary-400">
            © 2026{' '}
            <a href="https://vital.io" target="_blank" className="hover:text-white" rel="noopener">
              Vital
            </a>
            . All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  )
}
